/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：930
 */

module.exports = {
  publishDialog: "style_publishDialog__3O-QD",
  changePoster: "style_changePoster__3qvPb",
  required: "style_required__1new6",
  right: "style_right__3KUOh",
  title: "style_title__1WOUN"
}
